import Navigate from "common/router/Navigate";
import { useLocation } from "common/router/hooks";

import { INITIAL_CLIENT_DATA } from "client/common/utils";
import { urls } from "client/routes";

type ProtectedProps = {
  next?: string;
  children: React.ReactNode;
  requiresSignup?: boolean;
};

const { is_authenticated: isAuthenticated, has_completed_signup: hasCompletedSignup } =
  INITIAL_CLIENT_DATA;

const Protected = (props: ProtectedProps) => {
  const location = useLocation();

  const { next = location.current.pathname, children, requiresSignup = true } = props;

  const lookupPage = urls.accounts.lookup({
    search: { next },
  });
  const createPage = urls.accounts.signup({
    search: {
      next,
    },
  });

  if (!isAuthenticated) {
    return <Navigate dest={lookupPage} />;
  }

  if (requiresSignup && !hasCompletedSignup) {
    return <Navigate dest={createPage} />;
  }

  return <>{children}</>;
};

export default Protected;
